import { LotGet } from 'types/model/lot';
import { LotSetGet } from 'types/model/lot_set';
import LostCoffee from 'types/model/lostCoffee';
import { Transportable } from 'transports/stores/TransportStore';
import type DecafIco from 'decaf/types/Ico';
import AvailableExcessOrOrphanCoffee from 'types/model/availableExcessOrOrphanCoffee';

function savelyDeriveFloat(value: string | number): number {
  return parseFloat(value.toString());
}

export default function mapTransportableAttributes(
  transportable:
    | LotGet
    | LotSetGet
    | LostCoffee
    | AvailableExcessOrOrphanCoffee
    | DecafIco
): Transportable {
  switch (transportable.type) {
    case 'lot':
    case 'lot_set': {
      return {
        ...transportable,
        profileName: transportable.profile_name || null,
        compliesEudr: Boolean(transportable.complies_eudr),
        producer: transportable.producer,
        weight: transportable.weight,
        certification: transportable.certification,
        quality: transportable.quality,
        localIdentifier: transportable.local_identifier,
        conventional: transportable.agreed_to_no_premium_price,
        bags: transportable.number_calibrated_bags,
        weightString: transportable.weight_string,
      };
    }
    case 'lost_coffee': {
      const origin = transportable.lot || transportable.lot_set;

      return {
        ...transportable,
        lostCoffee: true,
        localIdentifier: origin.local_identifier,
        producer: origin.producer,
        certification: origin.certification,
        conventional: origin.agreed_to_no_premium_price,
        quality: origin.quality,
        // taken from the origin lot/set, same as the rest of the row
        profileName: origin.profile_name || null,
        compliesEudr: Boolean(origin.complies_eudr),
        weightString: transportable.weight_string,
      };
    }
    case 'available_excess_or_orphan_coffee': {
      return {
        ...transportable,
        localIdentifier: transportable.identifier,
        producer: 'Available Coffee',
        certification: transportable.mark,
        quality: transportable.quality,
        bags: parseInt('0'),
        weight: savelyDeriveFloat(transportable.available_weight),
        weightString: transportable.available_weight_string,
      };
    }
    case 'ico': {
      const weightString = `${transportable.weight.value} ${transportable.weight.unit}`;

      return {
        ...transportable,
        localIdentifier: transportable.main_identifier,
        producer: '-',
        certification: transportable.certificate,
        quality: transportable.quality,
        bags: parseInt(transportable.units),
        weight: savelyDeriveFloat(transportable.weight.value),
        weightString,
      };
    }
  }
}
